module.exports = __webpack_public_path__ + "images/category_lp/tablet_smartwatch/assessment_achievements/2_96dcf8c217751c45f067fdbd3dd49185.png";